import { useTranslation } from "react-i18next"
import { EPromotionApplyTargetType } from "../../Enum/EPromotionApplyTargetType"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useSnackbar } from "../../context/snackbarContext"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PostRequest } from "../../services/ApiClientService"

export interface ApplyPromotionRequest {
  targetType: EPromotionApplyTargetType
  mealIds: number[]
  drinkIds: number[]
  comboIds: number[]
}

export const useApplyPromotions = () => {
  const { t } = useTranslation(["general", "promotion"])

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { showSnackbar } = useSnackbar()

  const handleApplyPromotion = async (
    promotionId: number,
    request: ApplyPromotionRequest,
    onSuccess?: () => void,
  ) => {
    try {
      enableLoad()

      const response = await PostRequest(`${API_ROUTES.PROMOTION.APPLY}/${promotionId}`, request)

      if (response.success) {
        onSuccess?.()
        showSnackbar({
          title: t("promotion:snackbar_association_updated_title"),
          description: t("promotion:snackbar_association_updated_description"),
          variant: "success",
        })
        return true
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  const handleRemovePromotionApply = async (
    promotionId: number,
    request: ApplyPromotionRequest,
    onSuccess?: () => void,
  ) => {
    try {
      enableLoad()

      const response = await PostRequest(`${API_ROUTES.PROMOTION.APPLY_REMOVE}/${promotionId}/remove`, request)

      if (response.success) {
        onSuccess?.()
        showSnackbar({
          title: t("promotion:snackbar_association_removed_title"),
          description: t("promotion:snackbar_association_removed_description"),
          variant: "success",
        })
        return true
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)

      return false
    } finally {
      disableLoad()
    }
  }

  return { handleApplyPromotion, handleRemovePromotionApply }
}
